module.exports = __webpack_public_path__ + "static/media/cat2.11d923a9.jpg";